import Entity from 'utilities/Entity';

class Post extends Entity {}

export default new Post();